export default __webpack_public_path__ + "static/media/100.95572a6e.svg";